import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { VscNewFile, VscRefresh } from 'react-icons/vsc';
import { useDispatch, useSelector } from 'react-redux';
import AttenteRequete from '../../../../../hoc/AttenteRequete/AttenteRequete';
import { checkMot } from '../../../../../ressources/functionJS/checkMot';
import { getProjectIDTree } from '../../../../../ressources/functionJS/getProjectIDTree';
import { searchKeyInTree } from '../../../../../ressources/functionJS/searchKeyInTree';
import * as requestType from '../../../../../ressources/glossaires/glossaire_requetes';
import * as type_btn from '../../../../../ressources/glossaires/glossaire_type_de_bouton';
import * as glossaire_type_de_graphe from '../../../../../ressources/glossaires/glossaire_type_de_graphe';
import privet from '../../../../../ressources/Logo/close_p.png';
import off from '../../../../../ressources/Logo/off-f.png';
import on from '../../../../../ressources/Logo/on-f.png';
import publiq from '../../../../../ressources/Logo/open_p.png';
import * as actions from '../../../../../services/actions';
import Bouton from '../../../../UI/Bouton/Bouton';
import Tableau from '../../../../UI/tableau/Tableau';
import S from './TableauGraphe.module.scss';

// [field, labelKey, width, flex]
const COLUMN_CONFIG = [
  ['favoris', 'favoris', 80, 0],
  ['private', 'propriete', 150, 0],
  ['graph_id', 'id', 120, 0],
  ['project_id', 'projet', 180, 0],
  ['graph_name', 'nom', 200, 1],
  ['graph_type_id', 'type_de_graphe', 200, 1],
];

const createColumn = ({ field, labelKey, width, flex, projectsList, dispatch }) => {
  const baseColumn = {
    dataField: field,
    text: checkMot(labelKey),
    sort: true,
    ...(width ? { style: { width } } : {}),
    ...(flex && { flex }),
  };

  if (field === 'favoris') {
    return {
      ...baseColumn,
      align: 'center',
      headerAlign: 'center',
      formatter: (cell, row) => {
        const handleToggle = (e) => {
          e.stopPropagation();
          dispatch(actions.reqToggleFavoriteGraphV25(row.graph_id));
        };
        return (
          <button
            onClick={handleToggle}
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
          >
            {cell === 1 ? (
              <img alt="on" title="Favori" src={on} />
            ) : (
              <img alt="off" title="Non favori" src={off} />
            )}
          </button>
        );
      },
    };
  }

  if (field === 'private') {
    return {
      ...baseColumn,
      formatter: (cell) => {
        switch (parseInt(cell)) {
          case 1:
            return <img alt="prive" title="prive" src={privet} className="" />;
          case 0:
            return (
              <img alt="public" title="public" src={publiq} className="" />
            );
          default:
            return checkMot(cell);
        }
      },
      align: 'center',
      headerAlign: 'left',
    };
  }

  if (field === 'project_id') {
    return {
      ...baseColumn,
      hidden: true,
      formatter: (cell) => {
        for (let i = 0; i < projectsList.length; i++) {
          if (projectsList[i].project_id === cell) {
            return projectsList[i].project_name;
          }
        }
        return cell;
      },
    };
  }

  if (field === 'graph_name') {
    return {
      ...baseColumn,
      formatter: (cell, row) => (
        <span
          title={checkMot(
            Object.keys(glossaire_type_de_graphe).filter(
              (objKey) => glossaire_type_de_graphe[objKey] === row.graph_type_id
            )
          )}
        >
          {cell}
        </span>
      ),
    };
  }

  if (field === 'graph_type_id') {
    return {
      ...baseColumn,
      hidden: true,
      formatter: (cell) =>
        checkMot(
          Object.keys(glossaire_type_de_graphe).find(
            (key) => glossaire_type_de_graphe[key] === parseInt(cell)
          )
        ),
    };
  }

  return baseColumn;
};

const TableauGraphe = ({ creer, projetSelectione, siLaListeAUneValeur }) => {
  const dispatch = useDispatch();

  // Redux state
  const listeGraphes = useSelector((state) => state.graphe.graphs_list);
  const filtre_projects_list_id = useSelector(
    (state) => state.authentifie.filtre_projects_list_id
  );
  const project_id_url = useSelector(
    (state) => state.interfaceClient.project_id_url
  );
  const arborescence_projets = useSelector(
    (state) => state.interfaceClient.arborescence_projets
  );
  const interfaceAdmin = useSelector(
    (state) => state.authentifie.interfaceAdmin
  );
  const projects_list = useSelector((state) => state.authentifie.projects_list);
  const favorite_graphs_list = useSelector(
    (state) => state.graphe.favorite_graphs_list
  );

  // Split state into multiple useState hooks
  const [iconeCreer] = useState(<VscNewFile size={15} />);

  const handleSelectionChange = useCallback(
    (row) => {
      projetSelectione(row);
    },
    [projetSelectione]
  );

  const columns = useMemo(
    () =>
      COLUMN_CONFIG.map(([field, labelKey, width, flex]) =>
        createColumn({
          field,
          labelKey,
          width,
          interfaceAdmin,
          projectsList: projects_list,
          dispatch,
          ...(flex ? { flex } : {}),
        })
      ),
    [interfaceAdmin, projects_list, dispatch]
  );

  // Fetch favorites on mount
  useEffect(() => {
    dispatch(actions.reqRecupererFavoriteGraphsV25());
  }, [dispatch]);

  // Effect for initial data fetch and updates
  useEffect(() => {
    if (!isNaN(project_id_url) && project_id_url !== '') {
      const listeDesProjetsId = getProjectIDTree(
        searchKeyInTree(
          { nodes: arborescence_projets },
          parseInt(project_id_url)
        )
      );
      dispatch(actions.reqRecupererListeGraphes(listeDesProjetsId));
    } else if (filtre_projects_list_id.length > 0) {
      dispatch(actions.reqRecupererListeGraphes(filtre_projects_list_id));
    }
  }, [project_id_url, filtre_projects_list_id, arborescence_projets, dispatch]);

  const rafraichirTableau = () => {
    if (!isNaN(project_id_url) && project_id_url !== '') {
      const listeDesProjetsId = getProjectIDTree(
        searchKeyInTree(
          { nodes: arborescence_projets },
          parseInt(project_id_url)
        )
      );
      dispatch(actions.reqRecupererListeGraphes(listeDesProjetsId));
    } else {
      dispatch(actions.reqRecupererListeGraphes(filtre_projects_list_id));
    }
  };

  // Calculate filtered graphs list
  const listeGraphesAfficher =
    listeGraphes?.reduce((acc, graphe) => {
      if (interfaceAdmin) {
        if (filtre_projects_list_id.includes(parseInt(graphe.project_id))) {
          const isFavorite = favorite_graphs_list.includes(graphe.graph_id);
          acc.push({ ...graphe, favoris: isFavorite ? 1 : 0 });
        }
      } else {
        const listeDesProjetsId = getProjectIDTree(
          searchKeyInTree(
            { nodes: arborescence_projets },
            parseInt(project_id_url)
          )
        );
        const isFavorite = favorite_graphs_list.includes(
          parseInt(graphe.graph_id)
        );
        if (listeDesProjetsId.length === 0) {
          if (isFavorite) {
            acc.push({ ...graphe, favoris: 1 });
          }
        } else if (listeDesProjetsId.includes(parseInt(graphe.project_id))) {
          acc.push({ ...graphe, favoris: isFavorite ? 1 : 0 });
        }
      }
      return acc;
    }, []) || [];

  if (listeGraphesAfficher.length > 0) {
    siLaListeAUneValeur(true);
  }

  const validRows = useMemo(
    () =>
      (listeGraphesAfficher || []).filter(
        (row) => row.graph_id !== null && row.graph_id !== undefined
      ),
    [listeGraphesAfficher]
  );

  const selectRow = useMemo(
    () => ({
      mode: 'radio',
      clickToSelect: true,
      hideSelectAll: true,
      hideSelectColumn: true,
      style: () => ({
        background: '#eeb214',
        color: 'black',
      }),
      onSelect: (row) => {
        handleSelectionChange(row);
      },
    }),
    [handleSelectionChange]
  );

  return (
    <>
      <Tableau
        cleLigne="graph_id"
        donnees={validRows}
        colonnes={columns}
        selectionnerLignes={selectRow}
        iconeCreer={iconeCreer}
        creer={creer}
        hide_general_search={false}
      >
        <AttenteRequete
          request_type={requestType.recuperation_de_la_liste_des_graphes}
          str={checkMot('maj_graphes_en_cour')}
        >
          <Bouton
            hoverText={checkMot('refresh')}
            ajoutClass={S.btn}
            type={type_btn.outil}
            rond={true}
            cliquer={rafraichirTableau}
          >
            <VscRefresh size={15} />
          </Bouton>
        </AttenteRequete>
      </Tableau>
    </>
  );
};

export default TableauGraphe;
